// Generated by GitHub Copilot
import './index.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './components/pages/Home';
import OfferingDetail from './components/pages/OfferingDetail';
import ProtectedRoute from './components/auth/ProtectedRoute';
import GCCForum from './components/pages/GCCForum';
import WhyAccenture from './components/pages/WhyAccenture';
import ClientStories from './components/pages/ClientStories';
import GCCHealthCheck from './components/pages/GCCHealthCheck';
import DBStories from './components/pages/DBStories';
import InsightPage from './components/pages/InsightPage';
import IndustryNarratives from './components/pages/IndustryNarratives';
import CmdCenter from './components/pages/CmdCenter';
import { AlphaSenseTokenProvider } from './context/AlphaSenseTokenContext';
import NotFound from './components/pages/NotFound';

/**
 * Root application component.
 * Defines all client-side routes.
 * Every route is wrapped in ProtectedRoute to enforce SSO authentication.
 * To make a route public, simply omit the ProtectedRoute wrapper for that route.
 */
function App() {
  return (
    <BrowserRouter>
    <AlphaSenseTokenProvider>
      <Routes>
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Home />
            </ProtectedRoute>
          }
        />
        <Route
          path="/offering/:slug"
          element={
            <ProtectedRoute>
              <OfferingDetail />
            </ProtectedRoute>
          }
        />
        <Route
          path="/gcc-forums"
          element={
            <ProtectedRoute>
              <GCCForum />
            </ProtectedRoute>
          }
        />
        <Route
          path="/why-accenture"
          element={
            <ProtectedRoute>
              <WhyAccenture />
            </ProtectedRoute>
          }
        />
        <Route
          path="/client-stories"
          element={
            <ProtectedRoute>
              <ClientStories />
            </ProtectedRoute>
          }
        />
        <Route
          path="/gcc-health-check"
          element={
            <ProtectedRoute>
              <GCCHealthCheck />
            </ProtectedRoute>
          }
        />
        {/* SSO-protected — Client Stories require a valid Azure AD session */}
        <Route
          path="/clientstories"
          element={
            <ProtectedRoute>
              <DBStories />
            </ProtectedRoute>
          }
        />
        <Route
          path="/insight-page"
          element={
            <ProtectedRoute>
              <InsightPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/industry-narratives"
          element={
            <ProtectedRoute>
              <IndustryNarratives />
            </ProtectedRoute>
          }
        />
        <Route
          path="/cmdcenter"
          element={
            <ProtectedRoute>
              <CmdCenter />
            </ProtectedRoute>
          }
        />
        <Route path="*" element={<ProtectedRoute><NotFound /></ProtectedRoute>} />
      </Routes>
    </AlphaSenseTokenProvider>
    </BrowserRouter>
  );
}

export default App;
